import React, { FC, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Card, Col, Rate, Row, Spin } from "antd";
import styled from "styled-components";
import { SmallText } from "../../../Components/Text3D";
import { PrimaryButton } from "../../../Components/Button3D";
import { useQuery } from "@apollo/client";
import { MY_PRINTERS } from "../../../Apollo/graphql/Query";
import Img3D from "../../../Components/Model3D";
import NullDataComp from "../../../Components/NullDataComp";

const ContentWrapper = styled(Row)`
  background-color: #f7f7f7;
  margin-bottom: "2rem";
  /* margin-top: 1.25rem; */

  /* &:before{
      content: "";
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid white;
      margin-left: 360px;
    } */
`;
const ContentSection = styled(Col)`
  background-color: #fff;
  width: 100%;
`;
const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0.5rem;
  margin: 0 2rem;
  border-bottom: 1px solid #d8d8d8;
`;
const CardX = styled(Card)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);

  .ant-card-cover{
    height: 250px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    display: flex;
    .ant-image {
      height: 100%;
      text-align: center;
    }
  }
  .ant-card-body{
      padding: 1.5rem;
  }
`
const AnchorComp = styled(Link)`
  display: block;
  text-decoration: none;
`;

// const ImageCard = styled(Card)`
//   display: flex;
//   width: 100%;
//   justify-content: center;
//   align-items: center;
//   background-color: #3d3d3d;
//   height: 100%;
// `;
const Img = styled.img`
display: inline-block;
width: auto;
max-width: 100%;
height: 100%;
object-fit: contain;
`

const InfoDiv = styled.div`
    display: flex;
    flex-direction: column;
    .info-text{
        text-transform: capitalize;
    }
    .div-filament{
      margin-left: .5rem
    }
`

const MyPrinters: FC = () => {
  const [printers, setPrinters] = useState([]);
  const history = useHistory();

  // const user = JSON.parse(getUserData("user"));

  const { loading } = useQuery(MY_PRINTERS, {
    variables: {
      paginationInput: {
        page: 1,
        limit: 100,
      },
    },
    onCompleted: (data) => {
      setPrinters(data.myPrinters.printers);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  return (
    <Spin spinning={loading}>
      <ContentWrapper>
        <ContentSection>
          <TopSection>
            <SmallText small>
              <strong style={{ marginRight: "10px" }}>Total Printers:</strong>{" "}
              {printers.length} Items
            </SmallText>
            <PrimaryButton
              onClick={() => history.push("/dashboard/add/new/printer")}
            >
              ADD NEW
            </PrimaryButton>
          </TopSection>
          <div style={{ margin: "2rem" }}>
            <Row gutter={[32, 32]}>
              {loading && <NullDataComp />}
              {printers?.length === 0 && <NullDataComp />}
              {printers &&
                printers.map((printer: any) => {
                  return (
                    <Col
                      xl={{ span: 8 }}
                      md={{ span: 12 }}
                      sm={{ span: 24 }}
                      xs={{ span: 24 }}
                      key={printer._id}
                    >
                      <AnchorComp to={`/printers/${printer._id}`}>
                        <CardX
                          loading={false}
                          cover={
                            printer?.featuredImage?.endsWith(".stl") ? (
                              <Img3D url={printer?.featuredImage} />
                            ) : (
                              <Img src={printer?.featuredImage} alt="" />
                            )
                          }
                        >
                          <InfoDiv>
                            <div>
                              <strong className="info-text">
                                {printer?.name}
                              </strong>
                            </div>
                            <div>
                              <span className="info-text">
                                Brand: {printer?.brand}
                              </span>
                            </div>
                            <div>
                              <div className="info-text">
                                {"Filaments & Price:"}
                              </div>
                              <div
                                style={{ display: "flex", flexWrap: "wrap" }}
                              >
                                {printer?.filaments.map((sf: any, idx) => {
                                  return (
                                    <span key={idx}>
                                      {sf.name === "PLA_PLUS"
                                        ? "PLA+"
                                        : sf.name.replaceAll("_", " ")}
                                      : {`$${sf.price},`}
                                    </span>
                                  );
                                })}
                              </div>
                            </div>
                            <hr
                              style={{
                                width: "100%",
                                border: "1px solid #D8D8D8",
                              }}
                            />
                            <span>
                              Rating:{" "}
                              <Rate
                                defaultValue={printer?.averageStarRating}
                                style={{ paddingLeft: "1rem" }}
                                disabled
                              ></Rate>
                            </span>
                          </InfoDiv>
                        </CardX>
                      </AnchorComp>
                    </Col>
                  );
                })}
              {/* <Col span={8}>
                <ImageCard>
                  <img
                    src={Ellispe1}
                    alt=""
                    onClick={() => history.push("/dashboard/add/new/printer")}
                  />
                </ImageCard>
              </Col> */}
            </Row>
          </div>
        </ContentSection>
      </ContentWrapper>
    </Spin>
  );
};

export default MyPrinters;
